module.exports = __webpack_public_path__ + "static/media/do1.28c31a8a.png";